import { Box, ClickAwayListener, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./UploadTooltip.module.css";
import ImageAssets from "../../../assets";
import routesNames from "../../../routes/RouteNames";
import strings from "../../../strings/Strings";
import { useEffect } from "react";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageItem } from "../../../utils/LocalStorage";
import constants from "../../../core/constants/Constants";
import { getDashboardDataRequest } from "../../../redux/dashboard-redux/DashboardRedux";
import CommonDialog from "../../../components/common/dailog/common-dialog/CommonDialog";
import MobileDrawer from "../../../components/common/mobile-bottom-drawer/MobileDrawer";
import { AppBarEnum } from "../../../core/enumerations/AppBarEnum";
import { BottomSheetWithDialog } from "../../../components/common/bottom-sheet-with-dialog/BottomSheetWithDialog";
import { getCookies } from "../../../utils/Cookies";
import DownloadAppPopup from "../DownloadApp";

interface Props {
  toggleDrawer: (newOpen: boolean) => () => void;
}

const UploadTooltip = ({ setSelectedPath, isMobile }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openTooltipDialog, setOpenTooltipDialog] = useState(false);

  const [downloadAppPopup, setDownloadAppPopup] = useState(false);

  const dashboardState = useSelector((state: any) => state.dashboardRedux);

  const userDetails: any = getCookies(constants.userDetails);
  const loginUserDetails = JSON.parse(userDetails);

  useEffect(() => {
    dispatch(getDashboardDataRequest({ userId: loginUserDetails.id }));
  }, [dispatch]);

  const handleOpenTooltipDialog = () => {
    setOpenTooltipDialog(true);
  };

  const handleCloseTooltipDialog = (newOpen?: boolean) => {
    setOpenTooltipDialog(newOpen ?? false);
  };
  const [touchStartY, setTouchStartY] = useState(0);
  const [touchEndY, setTouchEndY] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStartY(e.touches[0].clientY);
  };

  const handleTouchEnd = () => {
    if (touchEndY > touchStartY + 50) {
      setSelectedPath(null);
      navigate(-1);
    }
  };

  const handleTouchMove = (e) => {
    setTouchEndY(e.touches[0].clientY);
  };

  const handleClose = () => {
    setSelectedPath("");
    navigate("/");
  }

  if (isMobile === true) {
    return (
      <>
        <BottomSheetWithDialog
          open={isMobile}
          onClose={() => {
            setSelectedPath(null);
            navigate(-1);
          }}
          width={"40rem"}
        >
          <div
            style={{
              backgroundColor: "var(--senary-theme-color)",
              padding: "20px",
              // paddingRight: "0",
              // marginLeft: "-19%",

              paddingBottom: "5rem",
              // marginRight: "-30%",
              paddingTop: "35px",
              // marginTop:"-20px",
              maxWidth: "100%",
              justifyContent: "center",
              alignItems: "center",
              // marginTop: "300%",
              position: "absolute",
              bottom: 0,
              right: 0,
              left: 0,
            }
            }
          >
            <div
              className={styles["new-container2"]}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <img
                className={styles["new-dash"]}
                src={ImageAssets.ic_dash}
                alt="new-post"
              />
            </div>
            <div className={styles["new-container3"]}></div>

            <div
              className={styles["mobile-container"]}
              onClick={() => {
                setDownloadAppPopup(true);
                // navigate(routesNames.createPost);
                // setSelectedPath("");
              }}
            >
              <span className={styles["new-post"]}>{strings.newPost}</span>
              <img
                className={styles["new-icons"]}
                src={ImageAssets.ic_new_post}
                alt="new-post"
              />
            </div>
            <div
              className={styles["mobile-container"]}
              onClick={() => {
                dashboardState?.dashboardData?.myProjectsCount > 0
                  ? navigate(routesNames.createProject)
                  : navigate(routesNames.createProject);
                setSelectedPath("");
              }}
            >
              <span className={styles["new-project"]}>{strings.newProject}</span>
              <img
                className={styles["new-icons"]}
                src={ImageAssets.ic_new_project}
                alt="new-project"
              />
            </div>
          </div>
        </BottomSheetWithDialog>

        {downloadAppPopup && <DownloadAppPopup open={downloadAppPopup} onClose={() => setDownloadAppPopup(false)} />}
      </>
    );
  }
  else
    return (
      <ClickAwayListener onClickAway={handleClose}>
        <div>
          <Box
            sx={
              isMobile
                ? {
                  position: "relative",
                  mt: "20px",
                  // "&::before": {
                  //   backgroundColor: "var(--senary-theme-color)",
                  //   content: '""',
                  //   display: "block",
                  //   position: "absolute",
                  //   width: 20,
                  //   height: 20,
                  //   bottom: -116,
                  //   transform: "rotate(45deg)",
                  //   left: "calc(50% - 6px)",

                  // },
                }
                : {
                  position: "relative",
                  mt: "20px",
                  // "&::before": {
                  //   backgroundColor: "var(--senary-theme-color)",
                  //   content: '""',
                  //   display: "block",
                  //   position: "absolute",
                  //   width: 20,
                  //   height: 20,
                  //   top: -6,

                  //   transform: "rotate(45deg)",
                  //   left: "3rem",
                  // },
                }
            }
          />
          <Stack
            flexDirection={"column"}
            sx={
              isMobile
                ? {
                  backgroundColor: "var(--senary-theme-color)",
                  padding: "20px",
                  paddingRight: "0",
                  marginLeft: "-19%",

                  paddingBottom: "10rem",
                  marginRight: "-30%",
                  paddingTop: "35px",
                  // marginTop:"-20px",
                }
                : {
                  p: 2,
                  backgroundColor: "var(--senary-theme-color)",
                  borderRadius: "12px",
                }
            }
          >
            <div
              className={styles["new-container2"]}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <img
                className={styles["new-dash"]}
                src={ImageAssets.ic_dash}
                alt="new-post"
              />
            </div>
            <div className={styles["new-container3"]}></div>

            <div
              className={styles["new-container"]}
              onClick={() => {
                setDownloadAppPopup(true);
                // navigate(routesNames.createPost);
                // setSelectedPath("");
              }}
            >
              <span className={styles["new-post"]}>{strings.newPost}</span>
              <img
                className={styles["new-icons"]}
                src={ImageAssets.ic_new_post}
                alt="new-post"
              />
            </div>
            <div
              className={styles["new-container"]}
              onClick={() => {
                dashboardState?.dashboardData?.myProjectsCount > 0
                  ? navigate(routesNames.createProject)
                  : navigate(routesNames.createProject);
                setSelectedPath("");
              }}
            >
              <span className={styles["new-project"]}>{strings.newProject}</span>
              <img
                className={styles["new-icons"]}
                src={ImageAssets.ic_new_project}
                alt="new-project"
              />
            </div>
          </Stack>

          {downloadAppPopup && <DownloadAppPopup open={downloadAppPopup} onClose={() => setDownloadAppPopup(false)} />}
        </div>
      </ClickAwayListener>
    );
};

export default UploadTooltip;
